import { EnhancedBaseService } from '../base/EnhancedBaseService';
import type { ServiceResponse } from '../base/ServiceTypes';

interface GenerateAIContentRequest {
  product: string;
  platform: string;
  modelName?: string;
  promptType?: string;
  customInstructions?: string;
  brandProfileId?: string | null;
  brandProfileName?: string;
  existingContent?: string;
  mediaUrls?: string[];
}

interface GenerateAIContentResponse {
  content: string;
}

class AIContentGenerationService extends EnhancedBaseService<GenerateAIContentResponse> {
  protected resourceName = 'ai-content-generation';

  /**
   * Generate AI content using edge function
   */
  async generateContent(request: GenerateAIContentRequest): Promise<ServiceResponse<string>> {
    return this.execute(async () => {
      const { data, error } = await this.client.functions.invoke('generate-ai-content', {
        body: request,
      });

      if (error) {
        throw new Error(error.message || 'Failed to invoke AI generation function.');
      }

      if (!data || typeof data.content !== 'string') {
        throw new Error('Received invalid response format from AI function.');
      }

      return data.content;
    });
  }
}

export const aiContentGenerationService = new AIContentGenerationService();
